import { Component, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { AccessLog } from '../access-log.model';
import { IdentityService } from 'src/app/identity/identity.service'
import { AuthService } from 'src/app/auth/auth.service'
import {GetAccessLogsResponse, GenericResponse, Esito} from '../../api-interfaces';
import { Observable } from 'rxjs';
import { Identity } from 'src/app/identity/identity.model'

@Component({
  selector: 'app-access-logs',
  templateUrl: './access-logs.component.html',
  styleUrls: ['./access-logs.component.sass']
})
export class AccessLogsComponent implements OnInit, OnDestroy {

  page: number = 1;
  pages: number;
  next: number;
  prev: number;
  isSpinning: boolean = false;
  private tplModal?: NzModalRef;
  public samlDetail: string;
  lockLeft = 0;
  lockRight = 1;

  listOfColumns: any[] = [
    {
      name: $localize`:Identity.AccessLogs.TableDate|label for date and time in table@@Identity.AccessLogs.TableDate:Data e ora`,
    },
    {
      name: $localize`:Identity.AccessLogs.TableLevel|label for level in table@@Identity.AccessLogs.TableLevel:Livello`,
    },
    {
      name: $localize`:Identity.AccessLogs.TableIPAddress|label for ip address in table@@Identity.AccessLogs.TableIPAddress:Indirizzo IP`,
    },
    {
      name: $localize`:Identity.AccessLogs.TableSAMLAssertion|label for saml assertion in table@@Identity.AccessLogs.TableSAMLAssertion:Asserzione SAML`,
    },
    {
      name: $localize`:Identity.AccessLogs.SPName|label for sp name in table@@Identity.SPName.TableIPAddress:SP Name`,
    },
    {
      name: $localize`:Identity.AccessLogs.SPUri|label for sp uri in table@@Identity.AccessLogs.SPUri:SP URI`,
    },
    {
      name: $localize`:Identity.AccessLogs.TableResult|label for result in table@@Identity.AccessLogs.TableResult:Esito`,
    },
  ];
  listOfData: AccessLog[];
  constructor(
    private authService: AuthService,
    private identityService: IdentityService,
    private modalService: NzModalService
  ) { }

  ngOnInit(): void {
    this.downloadAccessLogs();
    this.identityService.currentIdentityChanged
      .subscribe({
        next: (identity: Identity) => {
          this.downloadAccessLogs()
        }
      })
  }

  showModal(modal: TemplateRef<{}>, dataToShow: string): void {
    this.samlDetail = dataToShow;
    this.tplModal = this.modalService.create({
      nzTitle: "Richiesta SAML",
      nzContent: modal,
      nzFooter: null,
    });
  }

  ngOnDestroy(): void {
    this.tplModal?.destroy();
  }

  downloadAccessLogs() {
    this.isSpinning = true;
    this.identityService.getAccessLogs(this.page).subscribe(
      (response: GenericResponse) => {
        if (response["esito"] == "OK") {
          let accessLog: GetAccessLogsResponse = response["result"];
          this.listOfData = accessLog["results"];
          this.next = accessLog["next"];
          this.prev = accessLog["prev"];
          this.pages = accessLog["pages"];
        }
      },
      (err: Observable<never>) => { this.isSpinning = false; },
      () => { this.isSpinning = false; }
    );
  }

  onNext() {
    this.page = this.page + 1;
    this.downloadAccessLogs();
  }

  onPrev() {
    this.page = this.page - 1;
    this.downloadAccessLogs();
  }

  getStatusDisplay(data: string) {
    let parsedData = JSON.parse(data.replace(/'/g, '"'))
    return parsedData.code === 'Success' ? Esito.Ok : Esito.Ko
  }

  getStatusIcon(data: string) {
    let parsedData = JSON.parse(data.replace(/'/g, '"'))
    return parsedData.code === 'Success' ? 'assets/img/performed.svg' : 'assets/img/cancelled.svg';
  }
}
